// ElapsedTimer.jsx
import React, { useEffect, useState, useRef } from 'react';

export default React.memo(function ElapsedTimer({
  timestamp,        // ISO string or Date
  warnAfter = 16,   // minutes threshold
  onStaleChange     // optional callback if you need to react
}) {
  const [display, setDisplay] = useState('00:00');
  const staleRef = useRef(false);

  useEffect(() => {
    // if (!timestamp) return;
    // const start = new Date(timestamp).getTime();

    if (!timestamp) {
      setDisplay('00:00');
      return;
    }
     // Parse and clamp start‐time so it’s never in the future
    const parsed = new Date(timestamp).getTime();
    const start = parsed > Date.now() ? Date.now() : parsed;
    // const start = new Date(timestamp).getTime();

    const tick = () => {
      const diff = Date.now() - start;
      const hrs = Math.floor(diff / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

    //   const text = `${String(mins).padStart(2,'0')}:${String(secs).padStart(2,'0')}`;
      const formatted = hrs > 0
        ? `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
        : `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

      setDisplay(formatted);

      const totalMins = Math.floor(diff / 60000);

      const nowStale = totalMins >= warnAfter;
      if (nowStale !== staleRef.current) {
        staleRef.current = nowStale;
        if (onStaleChange) onStaleChange(nowStale);
      }
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [timestamp, warnAfter, onStaleChange]);

  // Only re‑renders when display changes
  return <span style={{ color: staleRef.current ? 'red' : 'black' }}>
    {display}
  </span>;
});
